'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TooltipIconStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var propTypes = {
  theme: _propTypes2.default.object
};

var style = function style(_ref) {
  var themeFromProvider = _ref.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var path = theme.reactackle.components.tooltipIcon.style;
  var fontFamily = theme.reactackle.fontFamily[theme.reactackle.body.fontFamily];
  var _theme$reactackle$com = theme.reactackle.components.tooltipIcon,
      diameter = _theme$reactackle$com.diameter,
      fontSize = _theme$reactackle$com.fontSize;
  return '\n    width: ' + (0, _reactackleCore.getValueString)(diameter) + ';\n    height: ' + (0, _reactackleCore.getValueString)(diameter) + ';\n    line-height: ' + (0, _reactackleCore.getValueString)(diameter) + ';\n    font-size: ' + (0, _reactackleCore.getValueString)(fontSize) + ';\n    border-radius: 50%;    \n    background-color: ' + path.backgroundColor + ';\n    color: ' + path.fontColor + ';\n\n    &:hover {\n      background-color: ' + path.hover.backgroundColor + ';\n      color: ' + path.hover.fontColor + ';\n      outline: none;\n    }\n\n    &:focus {\n      background-color: ' + path.focus.backgroundColor + ';\n      color: ' + path.focus.fontColor + ';\n      outline: none;\n    }\n    \n    &,\n    & *,\n    *::after,\n    *::before {\n      font-family: ' + fontFamily + ';\n      box-sizing: border-box;\n    }\n  ';
};

var TooltipIconStyled = exports.TooltipIconStyled = _styledComponents2.default.div.withConfig({
  displayName: 'TooltipIconStyled'
})(['display:inline-block;position:relative;text-align:center;flex-shrink:0;user-select:none;', ';', ';'], style, (0, _reactackleCore.transition)('color, background-color'));

TooltipIconStyled.propTypes = propTypes;
TooltipIconStyled.displayName = 'TooltipIconStyled';